"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useMutation_1 = require("./useMutation");
Object.defineProperty(exports, "useMutation", { enumerable: true, get: function () { return useMutation_1.default; } });
//# sourceMappingURL=index.js.map